import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "4",
  height: "17",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "1.7",
      cy: "1.7",
      r: "1.7",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.7",
      cy: "8.5",
      r: "1.7",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "1.7",
      cy: "15.3",
      r: "1.7",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }